import { render } from "./emailCompose.vue?vue&type=template&id=bac4ba7a&scoped=true"
import script from "./emailCompose.vue?vue&type=script&lang=js"
export * from "./emailCompose.vue?vue&type=script&lang=js"

import "./emailCompose.vue?vue&type=style&index=0&id=bac4ba7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac4ba7a"]])

export default __exports__